import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { logout } from './authSlice';
import { discountApiSlice } from './discountApiSlice';
import { normalizeActiveGlobalDiscount } from '../utils/activeGlobalDiscount';

const initialState = {
    activeGlobalDiscount: null,
    loading: false,
    error: null,
};

export const fetchActiveGlobalDiscount = createAsyncThunk(
    'activeGlobalDiscount/fetch',
    async (_, { dispatch, getState, rejectWithValue }) => {
        if (!getState().auth.userInfo) {
            return null;
        }

        const request = dispatch(
            discountApiSlice.endpoints.getActiveGlobalDiscount.initiate(undefined, {
                forceRefetch: true,
                subscribe: false,
            })
        );

        try {
            const data = await request.unwrap();
            if (!getState().auth.userInfo) {
                return null;
            }
            return data;
        } catch (error) {
            const message =
                error?.data?.message ||
                error?.error ||
                error?.message ||
                'No se pudo consultar el descuento';
            return rejectWithValue(message);
        } finally {
            request.unsubscribe();
        }
    }
);

const activeGlobalDiscountSlice = createSlice({
    name: 'activeGlobalDiscount',
    initialState,
    reducers: {
        clearActiveGlobalDiscount: (state) => {
            state.activeGlobalDiscount = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchActiveGlobalDiscount.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchActiveGlobalDiscount.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.activeGlobalDiscount = normalizeActiveGlobalDiscount(action.payload);
            })
            .addCase(fetchActiveGlobalDiscount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error?.message || null;
            })
            .addCase(logout, (state) => {
                state.activeGlobalDiscount = null;
                state.loading = false;
                state.error = null;
            });
    },
});

export const { clearActiveGlobalDiscount } = activeGlobalDiscountSlice.actions;

export const selectActiveGlobalDiscount = (state) =>
    state.activeGlobalDiscount.activeGlobalDiscount;

export default activeGlobalDiscountSlice.reducer;
